<div
    class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-min-w-256px cmps-cdk-bg-color-white cmps-cdk-p-0dot5 cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-gp-border-color-ukn-100 cmps-cdk-border-radius-8px cmps-uik-box-shadow-100"
>
    <div
        class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-pt-0dot5 cmps-cdk-pb-0dot25 cmps-cdk-px-0dot5"
    >
        <div
            class="cmps-cdk-font-size-12p cmps-cdk-text-uppercase cmps-cdk-letter-spacing-0dot05 cmps-gp-color-ukn-101 cmps-cdk-flex-grow-1"
        >
            {{ _i18n.__FILTER_BY_CATEGORY | translate }}
        </div>
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p cmps-cdk-color-blue-100 cmps-cdk-cursor-pointer cmps-cdk-m-0 cmps-cdk-p-0 focus:not:focus-visible:cmps-cdk-outline-0"
            (click)="_onClearPersonasClick()"
            *ngIf="_state.selectedPersonaFilterOptions?.size > 0"
        >
            {{ _i18n.__CLEAR | translate }}
        </button>
    </div>
    <div
        class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-gp-border-b-color-ukn-107 cmps-cdk-my-0dot5"
    ></div>
    <cmps-checkbox
        class="cmps-cdk-border-radius-4px hover:cmps-gp-bg-color-ukn-103 cmps-cdk-w-100pct nested:cmps-cdk-w-inherit nested:cmps-cdk-m-0 nested:cmps-cdk-p-0dot5"
        [checked]="_state.selectedPersonaFilterOptions?.has(p.personaType)"
        (change)="_onPersonaChange(p)"
        *ngFor="let p of _state.personaFilterOptions"
    >
        {{ p.persona?.label | translate }}
    </cmps-checkbox>
</div>
